import React, { Fragment } from "react";
import PropTypes from "prop-types";

const UploadTaxDocument = props => {
	const { taxExemptionRequest, uploadDocument } = props;
	const { lang } = global;
	let uploadInput = null;

	/** Creates an `onClick` ref for the hidden file input field to handle document uploads */
	const handleClick = () => uploadInput.click();

	return (
		<Fragment>
			<Choose>
				<When condition={taxExemptionRequest?.Approved === null}>
					<div className="label label-default">{lang.t("Pending")}</div>
				</When>
				<When condition={taxExemptionRequest?.Approved === false}>
					<div className="label label-danger">{lang.t("Denied")}</div>
				</When>
				<When condition={taxExemptionRequest?.Approved === true}>
					<div className="label label-success">{lang.t("Approved")}</div>
				</When>
			</Choose>
			<If condition={!taxExemptionRequest}>
				<div>
					<small>
						{lang.t(
							"Request tax exempt status by uploading the required documentation",
						)}
					</small>
				</div>
			</If>
			<div>
				<input
					name="tax-exemption-document"
					type="file"
					accept=".pdf,.png,.jpg"
					ref={ref => {
						uploadInput = ref;
					}}
					onChange={uploadDocument}
					className="hidden"
				/>
				<button
					type="button"
					id="tax-exemption-btn"
					className="btn btn-default"
					onClick={handleClick}
				>
					{lang.t("Upload Tax Exempt Documentation")}
				</button>
			</div>
		</Fragment>
	);
};

UploadTaxDocument.propTypes = {
	taxExemptionRequest: PropTypes.object,
	uploadDocument: PropTypes.func,
};

UploadTaxDocument.defaultProps = {
	taxExemptionRequest: {},
	uploadDocument: () => {},
};

export default UploadTaxDocument;
